import { Component, EventEmitter, Input, Output, Inject, OnInit } from '@angular/core';
import { User } from '@app/models/user.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Staff } from '@app/models/staff.model';
import { buddyUtils } from '@care-connect-japan/ckweblib';
import { UserSelect, UserSelectMode } from '@app/services/modal.model';

@Component({
  selector: 'app-modal-select-wrapper',
  template: `
    <app-modal-select
      [mode]="data.mode"
      [allowNull]="data.allowNull"
      [selectedId]="selectedId || []"
      [clear]="data.clear"
      [multiple]="data.multiple"
      [required]="data.required"
      (selectedChange)="select($event)"
      (multipleSelectChange)="multipleSelect($event)"
      (onCloseChange)="close()"
      (onClearChange)="clear()"
    ></app-modal-select>
  `,
})
export class ModalSelectWrapper {
  public selectedId: string[] = [];
  public currentId: string[] = [];
  constructor(
    public dialogRef: MatDialogRef<ModalSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: UserSelect
  ) {
    // clone data --> readonly properties may can not be change or 
    this.selectedId = buddyUtils.default.deepClone(data.selectedId);
  }

  select(selected: Staff | User) {
    this.multipleSelect([selected]);
  }

  multipleSelect(selected: any[]) {
    this.currentId = selected;
    this.dialogRef.close(this.currentId);
  }

  close() {
    this.dialogRef.close();
  }

  clear() {
    if (this.data.multiple) {
      this.selectedId = [];
    }
  }
}

@Component({
  selector: 'app-modal-select',
  template: `
    <!-- <app-modal-header (onCloseChange)="onCloseChange.emit()"></app-modal-header> -->
    <div class="contents" [style]="{marginBottom: '20%'}">
      <ng-container *ngIf="mode === userSelectMode.DAI; then dai; else staff"></ng-container>
      <ng-template #dai>
          <app-user-in-group-search 
          [multiple]="multiple || false" 
          [selectedId]="currentSelected"
          (usersChange)="multipleHandle($event)">
        </app-user-in-group-search>
      </ng-template>

      <ng-template #staff>
        <app-staff-in-team-search
          [multiple]="multiple || false" 
          [allowNull]="allowNull"
          [selectedId]="currentSelected"
          (staffsChange)="multipleHandle($event)"
        ></app-staff-in-team-search>
      </ng-template>
    </div>
    <form (submit)="submit($event)">
      <app-modal-footer
        [excuteText]="'選択'"
        [cancelText]="'キャンセル'"
        [disabled]="disableSubmit"
        (onCloseChange)="multipleSelectChange.emit(_selectedId)"
      ></app-modal-footer>

    </form>
  `,
})
export class ModalSelectComponent implements OnInit {
  @Input() allowNull?: boolean = true;
  @Input() mode: UserSelectMode = UserSelectMode.DAI;
  @Input() isTeam?: boolean;
  @Input() multiple?: boolean;
  @Input() required?: boolean;
  @Input('selectedId') _selectedId: string[] = [];
  @Output() selectedChange = new EventEmitter<Staff | User>();
  @Output() multipleSelectChange = new EventEmitter<string[]>();
  @Output() onCloseChange = new EventEmitter<void>();
  @Output() onClearChange = new EventEmitter<void>();
  userSelectMode = UserSelectMode
  excuteText?: string;
  currentSelected: string[] = [];
  @Input()
  set clear(clear: boolean | undefined) {
    if (clear) {
      this.excuteText = 'クリア';
    }
  }

  get disableSubmit() {
    if (!this.required) return false;
    return this.currentSelected.length === 0;
  }

  ngOnInit(): void {
    this.currentSelected = [...this._selectedId];
  }

  multipleHandle(selected: any[]) {
    this.currentSelected = selected.map(x => x.daicd || x.stfcd || null).filter(x => x != null);
  }

  submit(event: Event) {
    event.preventDefault();
    this.multipleSelectChange.emit(this.currentSelected);
    this.onClearChange.emit();
  }
}